import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import medal from '../../assets/icons/backOffice/sportsmedal.png';
import { H4, P2 } from '../../styles/FontStyles';
import { Box, Flexed } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { Icon, IconX } from '../../styles/Icons';
import { updatePackageRankNotification } from './Dashboard.actions';
import { PackageRankUpgradeNotification } from './Dashboard.types';
import {
  DashboardNotificationComponent,
  IconPosition
} from './DashboardStyled';

interface RankNotificationProps {
  notification: PackageRankUpgradeNotification;
}

export const RankNotification = ({ notification }: RankNotificationProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('dashboard');

  return (
    <Box>
      <DashboardNotificationComponent
        style={{ display: 'block', cursor: 'auto', width: '100%' }}>
        <Flexed between width='100%'>
          <Flexed>
            <Icon color={colors.neutral900}>
              <img src={medal} style={{ width: 52, marginRight: 20 }} alt='' />
            </Icon>
            <div>
              <H4>{t('notifications.congratulations')}</H4>
              <P2 mt='8'>
                {t('notifications.you_become')}{' '}
                <b>“{notification?.packageRank?.name}”</b>{' '}
                {t('notifications.by_rank')}
              </P2>
            </div>
          </Flexed>

          <IconPosition>
            <Icon
              color={colors.neutral900}
              pointer
              onClick={() => {
                dispatch(updatePackageRankNotification(notification.id));
              }}>
              <IconX />
            </Icon>
          </IconPosition>
        </Flexed>
      </DashboardNotificationComponent>
    </Box>
  );
};
